import QRCode from 'qrcode';
import {activeShareLink} from './share';


async function setQrCodeVisitor() {
    const qrcodeTag = document.getElementById('qrcode-visitor');
    const qrcodeArea = document.getElementById('qrcode-area');
    const qrcodeContent = document.getElementById('qrcode-content');
    const qrcodeShareLink = document.getElementById('qrcode-share-link');
    if(qrcodeTag){
        const dataQrCode = await QRCode.toString(qrcodeContent.value, {small: true});
        qrcodeTag.insertAdjacentHTML( 'beforeend', dataQrCode );
        
        activeShareLink(qrcodeShareLink, {
            title: 'Amora',
            text: 'Compartilhe o acesso',
            url: window.location.href
        });
    }
}




setQrCodeVisitor();